import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateUrl',
})
export class TruncateUrlPipe implements PipeTransform {
  transform(rawLink: any): any {
    const urlRegex = /(https?:\/\/)/g;
    const trimUrl = rawLink.replace(urlRegex, '');
    const parts = trimUrl.split('/');
    if (parts.length > 2) {
      return `${parts[0]}/.../${parts[parts.length - 1]}`;
    } else {
      return trimUrl;
    }
  }
}
